import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Image from '../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';
import RadioButton from '../../../../../components/ZUILib/RadioButton';

const applicationRoutes = commonUtil.getApplicationRoutes();

const defaultGiftImage = commonUtil.getAssetURL() + '/images/guest/gift.png';
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

export default class ClosingGiftPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bridgeCoreRequestMessage: this.props.bridgeCoreRequest,
    };
  }
  redirectToDatosDeMiEvento = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'RegaloPorCierre', eventID: this.props.eventID }));
  }

  render() {
    const { submitTransferenceData } = this.props;
    const clickLink = {
      cssClass: 'text-pink',
      onClickHandler: this.redirectToDatosDeMiEvento,
    };
    const getImageAttr = (imgURL, type, index) => {
      const imageAttr = {
        id: 'closingGiftRow' + index,
        src: imgURL,
        alt: '',
        altImg: defaultGiftImage,
        className: type === 'verificationForm' ? 'closingGiftImg' : 'closingGiftImg',
      };
      return imageAttr;
    };

    const closingRow = {
      border: 'none',
      boxShadow: 'none',
      paddingTop: 0,
    };

    const store = {
      border: 'none',
      paddingLeft: 0,
      paddingTop: 0,
    };

    const webGiftImg = {
      textAlign: 'left',
      width: '20px',
      marginTop: '10px',
      paddingLeft: 0,
    };

    const storeLbl = {
      paddingTop: '12px',
      color: '#333333',
      textTransform: 'uppercase',

    };

    const bridgeCoreRequestLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.setState({ bridgeCoreRequestMessage: null }); },
    };
    const closingGiftRow = (data, index) => (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div>
            <table className="giftsTable">
              <tbody><tr style={{ border: 'none' }}>
                <td style={{ width: '20px', paddingRight: 0, paddingLeft: 0 }}>
                  <Image
                    style={{ height: '30px' }}
                    imageAttr={getImageAttr(data.skuImage, 'closureConfirmation', index)}
                  />
                </td>
                <td className="product"><a href>{data.skuName}</a></td>
              </tr>
              </tbody></table>
            <p style={{ fontWeight: '400', color: '#333333' }}> {!_.isEmpty(data.remisionNumber) ? ('Entrega en domicilio: ' + data.addressName) : 'Entrega a tienda'}</p>
          </div>
          : <div key={index} className="content divTR" style={closingRow}>
            <div
              className="col-xs-4 mb10 text-align-center"
              style={webGiftImg}
            >
              <Image
                style={{ height: '30px' }}
                imageAttr={getImageAttr(data.skuImage, 'closureConfirmation', index)}
              />
            </div>
            <div className="col-xs-8 mb10">
              <p style={storeLbl}>{data.skuName}</p>
            </div>
            <div className="col-xs-12 closing-bottom-detail" style={store}>
              {!_.isEmpty(data.remisionNumber) ? <React.Fragment>
                <div className="col-xs-6 closing-border-right">
                  <span>No. de remision: {data.remisionNumber}</span>
                </div>
                <div className="col-xs-6">
                  <span>Entrega a domicilio: {data.addressName}</span>
                </div>
              </React.Fragment>
                : <div className="col-xs-12" style={{ paddingLeft: 0 }}>
                  <span style={{ fontWeight: '400', color: '#333333' }}>Entrega en tienda</span>
                </div>}
            </div>
          </div>}
      </React.Fragment>);

    return (
      <React.Fragment>
        {!_.isEmpty(submitTransferenceData) && (!_.isEmpty(submitTransferenceData.skus) || !_.isEmpty(submitTransferenceData.gifts)) ?
          <div className="closingGiftPanel mb10">
            <div
              style={channel === constChannels.WEB ? { width: '100%', marginTop: '3rem' } : { marginTop: '20px' }}
              className={channel === constChannels.WEB ? 'block-verification' : 'col-xs-12 innerOptions innerGifts mb10'}
            >
              {channel === constChannels.WEB ?
                <div className="titleSection">Regalo por cierre</div>
              : <p
                style={{
                  fontSize: '22px',
                  color: '#333333',
                  fontWeight: '400',
                }}
              >Regalo por cierre</p>}
              <React.Fragment>
                {this.props.loadFrom === 'verificationForm' ?
                  <React.Fragment>
                    <p className="giftText">
                      <p>
                        <span style={{ color: '#333333' }}>
                          {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.closingGift.message1')}
                        </span>
                      </p>
                      {submitTransferenceData.gifts.map((gift, index) => (
                        <div
                          style={channel === constChannels.WAP ?
                          { fontSize: '16px', color: '#333333', fontWeight: '400' }
                          : null
                        }
                          className={channel === constChannels.WEB ? 'mt10' : 'giftText'}
                        >
                          <Image imageAttr={getImageAttr(gift.skuImage, 'verificationForm', index)} /> {gift.skuName}
                        </div>),
                      )}</p>
                    <div className="mt-15">
                      {submitTransferenceData.selectedAddressName ?
                        <p>Entrega a domicilio: {submitTransferenceData.selectedAddressName}</p>
                        : <p
                          style={{
                            fontSize: '16px',
                            color: '#333333',
                            fontWeight: '400',
                          }}
                        >Entrega en Tienda</p>}
                    </div>
                  </React.Fragment>
                  : <div>
                    {channel === constChannels.WEB ? <p>Regalo seleccionado</p> : ''}
                    {channel === constChannels.WAP ?
                      <strong>
                        <span style={{ color: '#333333', fontWeight: '400' }}>Regalo seleccionado</span>
                      </strong>
                    : null}
                    {submitTransferenceData.skus.map((closingGiftRow))}
                  </div>
                }
              </React.Fragment>
            </div>
          </div> : null}
      </React.Fragment >);
  }
}
